<template>
    <div class='noticeDetail'>
        <div class="title font18">{{details.title}}</div>
        <div class="con font16" v-for='(item,i) in details.trainList' :key='i'>
             <p class="tit">{{item.content}}</p>
             <p class="link" v-for='(obj,j) in item.guidances' :key='j' @click='toDetail(obj)'>
                <svg-icon icon-class="img" v-if="obj.fileType==1"/>
                <svg-icon icon-class="media" v-else-if="obj.fileType==2"/>
                <svg-icon icon-class="word" v-else/>
                <span class="text">{{obj.fileName}}</span>
             </p>
        </div>
        <div class='remark' v-if="details.remark">备注说明：{{details.remark}}</div>
    </div>
</template>
  <script>
  export default {
      data() {
        return {
          details:'',
        }
      },
      created(){
         this.details=JSON.parse(sessionStorage.noticeCon);
      },
      methods: {
        toDetail(item){
            location.href=item.url;
        }
      },
    }
  </script>
  <style lang="scss" >
  .noticeDetail{
     background: #fff;
     padding:.15rem .24rem .2rem;
     color:rgba(0,0,0,.9);
     .title{
        border-bottom: 1px solid #DCDCDC;
        padding-bottom: .15rem;
     }
     .con{
        padding:.15rem 0rem 0rem;
        .tit{
          padding-bottom: .15rem;
        }
        .svg-icon{
            width:.25rem;
            height: .25rem;
            vertical-align: middle;
        }
        .text{
          display: inline-block;
          margin-left: .1rem;
          width: 70%;
          vertical-align: text-top;
        }
        .link{
            color:#0A59F7;
            margin-bottom: .1rem;
            &:last-child{
              margin-bottom: 0rem;
            }
        }
     }
     .remark{
      padding-top: .15rem;
     }
  }
  
  </style>